<img loading="lazy" [src]="categoryImageUrl" itemprop="image" [alt]="category().name" />
